<template>
  <canvas :id="chartId" width="300px" height="400px"></canvas>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: "Buffer",
  props: {
    red: Number,
    yellow: Number,
    green: Number,
    flowEquation: Number,
    withFlowEquation: Boolean,
    renderBuffer: Boolean,
    chartId: String
  },
  data: () => ({
    chart: null,
    chartData: {
      type: 'line',
      data : {
        labels : [],
        datasets : []
      },
      options: {
        layout: {
          padding: {
            left: 50,
            right: 50
          }
        },
        legend: {
          display: true,
          position: "bottom"
        },
        tooltips: {
            mode: 'index',
            intersect: false,
            itemSort: (a, b) => b.value - a.value,
            titleFontSize: 0
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true,
                suggestedMax: 35
            }
          }]
        }
      }
    }
  }),
  methods: {
    async render() {
      this.chartData.data.datasets  = this.series()
      if (this.withFlowEquation) {
        this.chartData.options.legend.display = false
      } else {
        this.chartData.options.legend.display = true
      }
      if (!this.chart) {
        this.chart = new Chart(document.querySelector("#" + this.chartId), this.chartData)
      } else {
        this.chart.update({easing: "easeOutBack"})
      }
    },
    series() {
      let series = [];
      if (this.withFlowEquation) {
        series.push({
          label: this.$t("stats.flowEquation"),
          type: "line",
          backgroundColor: "#0000ff",
          borderColor: "#0000ff",
          fill: false,
          data: [this.flowEquation, this.flowEquation]
        });
        series.push({
          label: this.$t("stats.stock"),
          type: "line",
          backgroundColor: "#000000",
          borderColor: "#000000",
          fill: false,
          data: [this.$store.getters['company/stock'], this.$store.getters['company/stock']]
        });
      }
      series.push({
        label: this.$t("stats.red"),
        type: "line",
        backgroundColor: '#ff0000',
        data: [this.red, this.red]
      });
      series.push({
        label: this.$t("stats.yellow"),
        type: "line",
        backgroundColor: '#ffff00',
        data: [this.yellowTop, this.yellowTop]
      });
      series.push({
        label: this.$t("stats.green"),
        type: "line",
        backgroundColor: '#008000',
        data: [this.greenTop, this.greenTop]
      });
      
      return series;
    }
  },
  computed: {
    greenTop() {
      return this.red + this.yellow + this.green;
    },
    yellowTop() {
      return this.red + this.yellow;
    }
  },
  watch: {
    renderBuffer(val) {
      if (val) {
        this.render()
      }
    }
  }
};
</script>